import { useEffect, useState } from 'react';
import { getTrainers } from '../api/admin';
import { AuthProvider } from '../lib/http-service';

export function useIsSuperAdmin(auth: AuthProvider) {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTrainers(auth)
      .then(() => setIsSuperAdmin(true))
      .catch(() => setIsSuperAdmin(false))
      .finally(() => setLoading(false));
  }, []);

  return { isSuperAdmin, loading };
}
